import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin  from '@fullcalendar/list';
import { TranslationService } from 'src/app/services/translation.service';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { ApiService } from 'src/app/services/api.service';
import * as moment from 'moment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { ics } from 'ics-file-export';

@Component({
  selector: 'app-roadmap',
  templateUrl: './roadmap.component.html',
  styleUrls: ['./roadmap.component.css']
})
export class RoadmapComponent implements OnInit {
  activityArray: Array<any> = [];
  listActivityArray: Array<any> = [];
  view = 'list';
  postoutcomes = [];
  modalRefForm: BsModalRef;
  calendarPlugins = [dayGridPlugin ];
  mindate = new Date();
  loading: Boolean = true;
  loagActivityData: any = null;
  activityData: any;
  logActivity: Boolean = false;
  logManually: Boolean = false;
  bsInlineValue = new Date();
  bsInlineRangeValue: Date[];
  maxDate = new Date();
  calendarApi;
  calenderView = 'dayGridWeek';
  arrayToDisplay = [];
  categories: Array<any> = [];
  events = [];
  @ViewChild('fullcalendar') fullcalendar: FullCalendarComponent;
  icsCal = ics();

  constructor(
    public translations: TranslationService,
    private apiservice: ApiService, 
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.icsCal = ics();
    // this.icsCal.addEvent('Christmas', 'Christian holiday celebrating the birth of Jesus Christ', 'Bethlehem', '8/7/2013 5:30 pm', '10/7/2013 3:10 pm');

    // this.icsCal.addEvent('Christmas', '', '', moment(new Date()).add(1, 'days').format("MM/DD/YYYY h:mm:ss a"), moment(new Date()).add(4, 'days').format("MM/DD/YYYY h:mm:ss a"));
    
    if (this.apiservice.user.profiles) {
      this.apiservice.getProfileById(this.apiservice.user.profiles._id, this.apiservice.user._id).subscribe((res: any) => {
       let cate = res.data.categoryMap.map(cat => {
          cat['category']['goals'] = cat['goals'];
          return cat;
        });
        cate.sort(function(a, b) {
          return a.rank - b.rank;
        });
        cate.forEach((element, index) => {
          let status = index == 0 ? true : false;
          this.categories.push({ _id: element.category._id, name: element.category.title, color: element.category.color, status: status });
        });
        this.getRoadMapData();
      })
    } else {
      this.apiservice.getCreatedCategories(this.apiservice.user._id).subscribe((res: any) => {
        let cate = res.data.map(cat => {
          cat['category'] = cat;
          return cat;
        });
        cate.forEach((element, index) => {
          let status = index == 0 ? true : false;
          this.categories.push({ _id: element.category._id, name: element.category.title, color: element.category.color, status: status });
        });
        this.getRoadMapData();
      });
    }
  }

  ngAfterViewChecked() {
    this.calendarApi = this.fullcalendar.getApi();
  }

  changeView(view) {
    this.calenderView = view;
    this.calendarApi.changeView(view);
  }

  dateChange(e) {
    if (this.calendarApi) {
      this.calendarApi.gotoDate(e);
    }
  }
  openFormModal(template: TemplateRef<any>, event) {
    this.modalRefForm = this.modalService.show(template, { class: 'modal-md' });
    this.eventClicked(event);
  }

  cancelGenerate() {
    this.modalRefForm.hide();
  }


  getRoadMapData() {
    this.loading = true;
    let array = [];
    this.categories.forEach(ele => {
      if (ele.status)
        array.push(ele._id);
    });
    let temp = this.apiservice.user.profiles ? this.apiservice.user.profiles : null;

    this.apiservice.getroadMapData({ id: array, user: this.apiservice.user._id, profile: temp }).subscribe((res: any) => {
      this.events = [];
      this.activityArray = [];
      this.listActivityArray = [];
      if (this.apiservice.user.profiles) {
        res.data = res.data['categoryMap'];
        res.data = res.data.map(t => {
          t['color'] = t.category.color;
          t['_id'] = t.category._id;
          return t;
        });
      }
      console.log(res.data);
      res.data.forEach(ele => {
        ele.goals.forEach(goals => {
          goals.activityMap.forEach(aci => {
            let startDate = moment(aci.createdAt).add(aci.startAfter, 'days').set({ h: aci.startHour, m: aci.startMinute });
            aci['startDate'] = startDate.toDate();
            let status = true;

            for (let i = 0; i < aci.doFor; i++) {
              if (status) {
                this.events = this.events.concat({ title: aci.activity.title, start: moment(aci['startDate']).add(i, 'days').format("YYYY-MM-DDTHH:mm:ss"), end: moment(aci['startDate']).add(i, 'days').add(aci.duration, 'minutes').format("YYYY-MM-DDTHH:mm:ss"), backgroundColor: ele.color, borderColor: ele.color, textColor: 'black' });
              }

              this.icsCal.addEvent(aci.activity.title, '', '', moment(aci['startDate']).add(i, 'days').format("MM/DD/YYYY h:mm:ss a"), moment(aci['startDate']).add(i, 'days').add(aci.duration, 'minutes').format("MM/DD/YYYY h:mm:ss a"));

              if (aci.frequency == 'Once') {
                status = false;
              }
              if (aci.frequency == 'Daily') {
                status = true;
              }
              if (aci.frequency == 'Alternate Days') {
                status = status ? false : true;
              }
              if (aci.frequency == 'Weekly') {
                status = (i + 1) % 7 == 0 ? true : false;
              }
              if (aci.frequency == 'Monthly') {
                status = (i + 1) % 30 == 0 ? true : false;
              }
            }
            this.activityArray.push({ category: ele._id, goal: goals._id, actId: aci.activity._id, actTitle: aci.activity.title, frequency: aci.frequency, duration: aci.duration, URL: aci.URL , goalTitle: goals.title })
            let repeated = this.listActivityArray.filter(el => el.actTitle == aci.activity.title);
            if (repeated.length == 0) {
              this.listActivityArray.push({ actTitle: aci.activity.title, category: ele.category.title, goal: goals.title, color: ele.color, frequency: aci.frequency, duration: aci.duration, URL: aci.URL   })
            }

            console.log(this.listActivityArray);
          });
        });
      });
      this.loading = false;
    })
  }

  exportCalendarToICSFile() {
    // console.log(this.icsCal.calendar());
    this.icsCal.download('roadmap');
  }

  eventClicked(event) {
    let data = this.activityArray.filter(ele => ele.actTitle == event.event.title);
    this.loagActivityData = data[0];
    // this.logActivity = true;
  }

  logHere(event, modalOpen = 'yes') {
    if(modalOpen == 'yes') {
      this.cancelGenerate();
    }
    let data = this.activityArray.filter(ele => ele.actTitle == event.actTitle);
    this.loagActivityData = data[0];
    this.logActivity = true;
  }

  openManualForm(event) {
    this.activityData = event.activityData;
    this.postoutcomes = event.postoutcomes;
    this.logManually = true;
  }


}
